<template>
    <!-- 业绩统计 -->
    <div class="statistics">
        <div>
          <div class="row-four">各策略净值走势图</div>
          <div class="time-tab">
            <span>选择时间：</span>
            <el-radio-group v-model="netValTime" class="radio-btnt" value-key="id" @change="getStrategyNetValueCharts">
                <el-radio-button label="0" >今年以来</el-radio-button>
                <el-radio-button label="2" >最近一月</el-radio-button>
                <el-radio-button label="3" >最近三月</el-radio-button>
                <el-radio-button label="4" >最近半年</el-radio-button>
                <el-radio-button label="5" >最近一年</el-radio-button>
                <el-radio-button label="7" >最近五年</el-radio-button>
                <el-radio-button label="-1">成立以来</el-radio-button>
            </el-radio-group>
          </div>
          <div style="width:100%;height:383px;" id="cljz"></div>
        </div>
        <div class="mt70">
            <div class="row-four">各策略业绩分布图</div>
            <div class="time-tab">
                <span>选择时间：</span>
                <el-radio-group v-model="achievementTime" class="radio-btnt" value-key="id" @change="getStrategyYieldDistr">
                    <el-radio-button label="-1">成立以来</el-radio-button>
                    <el-radio-button label="2">最近一月</el-radio-button>
                    <el-radio-button label="3">最近三月</el-radio-button>
                    <el-radio-button label="4">最近半年</el-radio-button>
                    <el-radio-button label="5">最近一年</el-radio-button>
                    <el-radio-button label="6">最近三年</el-radio-button>
                    <el-radio-button label="7">最近五年</el-radio-button>
                    <el-radio-button label="0">今年以来</el-radio-button>
                </el-radio-group>
            </div>
            <highcharts :option="optionGclsyfb" id="syfb"></highcharts>
        </div>
        <el-row class="row-two mt20 form-inline">
            <h3 class="title">全市场各策略月度收益</h3>
            <el-date-picker type="month" v-model="monthDate" placeholder="选择日期" value-format="yyyy-MM" style="width:150px;margin-left: 50px;" :clearable="false"></el-date-picker>
        </el-row>
        <div class="mt30">
            <div v-for="(item,i) in tacticsArr" :key="i+'g'">
                <ul class="row-h"><li v-for="(val1,i1) in item" :key="i1+'ydsy'">{{val1.secuNameAbbr}}</li></ul>
                <ul class="row-b"><li v-for="(con1,c1) in item" :key="c1+'ydsyz'">{{parseFloat(con1.yield*100).toFixed(2)}}%</li></ul>
            </div>
        </div>
        <el-row class="row-two mt20 form-inline">
            <h3 class="title">全市场指数月度收益</h3>
            <el-date-picker type="month" v-model="zsmonthDate" placeholder="选择日期" value-format="yyyy-MM" style="width:150px;margin-left: 50px;" :clearable="false"></el-date-picker>
        </el-row>
        <div class="mt30">
            <div v-for="(item,i) in indexMonthYield" :key="i+'g'">
                <ul class="row-h"><li v-for="(val1,i1) in item" :key="i1+'ydsy'">{{val1.secuNameAbbr}}</li></ul>
                <ul class="row-b"><li v-for="(con1,c1) in item" :key="c1+'ydsyz'">{{parseFloat(con1.yield*100).toFixed(2)}}%</li></ul>
            </div>
        </div>
        <el-row class="row-two mt20 form-inline">
            <h3 class="title">睿选50策略指数月度收益</h3>
            <el-date-picker type="month" v-model="rxMonthDate" placeholder="选择日期" value-format="yyyy-MM" style="width:150px;margin-left: 50px;" :clearable="false"></el-date-picker>
        </el-row>
        <div class="mt30">
            <div v-for="(item,i) in strategyArr" :key="i+'r'">
                <ul class="row-h"><li v-for="(val2,i2) in item" :key="i2+'rxsy'">{{val2.secuNameAbbr}}</li></ul>
                <ul class="row-b"><li v-for="(con2,c2) in item" :key="c2+'rxsyz'">{{parseFloat(con2.yield*100).toFixed(2)}}%</li></ul>
            </div>
        </div>
        <!-- 相关性表格 -->
        <div class="mt70">
            <strategicAnalysis></strategicAnalysis>
        </div>
        <div class="mt70">
            <div class="row-four mb30">策略指标</div>
            <performanceAnalysis></performanceAnalysis>
        </div>
    </div>
</template>

<script>
import highcharts from "../../components/highcharts";
import strategicAnalysis from '../policyEvaluation/strategicAnalysis.vue';
import performanceAnalysis from "./performanceAnalysis.vue"
export default {
  name: "performanceStatistics",
  components: {
    highcharts,
    strategicAnalysis,
    performanceAnalysis,
  },
  data () {
    return {
        optionGclsyfb: {
            chart: { type: 'bar' },
            title: { text: '' },
            colors: ['#16B82D', '#5BCD6C', '#A2E3AB', '#EBBDBD', '#CD5B5B', '#B81616'],
            xAxis: {
            categories: [],
            gridLineWidth: 1, //y轴对应显示的横线粗细
            gridLineDashStyle: 'Dash',
            gridLineColor: 'rgba(0,0,0,0)',
            Color: 'rgba(0,0,0,0)',
            labels: {
                formatter: function () {
                return this.value
                },
                style: {
                fontSize: "13px",
                color: '#333333'
                },
                x: -30,
                y: 6
            }
            },
            yAxis: {
            min: 0,
            title: {
                text: ''
            },
            reversed: true,
            gridLineWidth: 1, //y轴对应显示的横线粗细
            gridLineDashStyle: 'Dash',
            gridLineColor: 'rgba(0,0,0,0)',
            labels: {
                formatter: function () {
                return this.value
                },
                style: {
                color: 'rgba(0,0,0,0)'
                }
            }
            },
            legend: {
            symbolRadius: 0,
            align: 'center',
            symbolHeight: 15,
            borderWidth: 0,
            y: -25,
            },
            plotOptions: {
            series: {
                stacking: 'percent',
            },
            },
            series: [],
            credits: { enabled: false },
            tooltip: {
            style: {
                fontSize: "12px",
                fontFamily: "Courir new",
                color: "white",
            },
            useHTML: true,
            backgroundColor: 'rgba(0,0,0,0.6)', // 背景颜色
            borderRadius: 10, // 边框圆角
            borderColor: 'none', // 边框颜色
            shadow: false, // 是否显示阴影
            }
        },
        netValTime: '0', //0今年以来,2近一月,3近三月,4近六月,5近一年,6近三年,7近五年,-1成立以来
        achievementTime: '-1', //0今年以来,2近一月,3近三月,4近六月,5近一年,6近三年,7近五年,-1成立以来
        tacticsArr: [],
        indexMonthYield: [],
        monthDate: '',
        rxMonthDate: '',
        zsmonthDate: '',
        strategyArr: [],
    }
  },
  mounted () {
    this.getStrategyNetValueCharts()
    this.getStrategyYieldDistr()
    this.monthDate = this.$commonJs.timeFormat('','yyyy-mm','minus')
    this.rxMonthDate = this.$commonJs.timeFormat('','yyyy-mm','minus')
    this.zsmonthDate = this.$commonJs.timeFormat('','yyyy-mm','minus')
  },
  watch: {
    monthDate:{
       handler(val){
            this.getStrategyMonthYield()
       },
       deep:false
    },
    rxMonthDate:{
       handler(val){
            this.getHCStrategyMonthYield()
       },
       deep:false
    },
    zsmonthDate:{
       handler(val){
            this.getMarketIndexMonthYield()
       },
       deep:false
    }
  },
  methods: {
    // 业绩分布
    getStrategyYieldDistr () {
      let vm = this
      vm.$http.post(vm.$apiPath.GetStrategyYieldDistr, {
        Region: vm.achievementTime,
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {
          // 各策略业绩收益分布
          let newNameList = res.data.data.dateList, seriesData = [], newDataList = res.data.data.dataList.slice(1)
          vm.optionGclsyfb.xAxis.categories = res.data.data.nameList.slice(1)
          newNameList.forEach((val, ind) => {
            let dataD = [];
            newDataList.forEach((v, i) => {
              dataD.push(v[ind])
            })
            seriesData.push({
              name: val,
              data: dataD
            })
          })
          vm.optionGclsyfb.series = seriesData;
        }
      }).catch(err => { })
    },
    // 策略净值走势图
    getStrategyNetValueCharts() {
        let vm = this;
        vm.$http.post(vm.$apiPath.GetStrategyNetValueCharts,{
            Region: vm.netValTime,
        }).then(res=>{
            // console.log(res);
            if(res.data.code == 200) {
                let xdata = res.data.data
                let seriesData = [];
                let color = ['#B81616','#E48A0A','#EDC718','#7DBA1C','#22A1CB','#C053E0','#794AC0','#1C6ABA','#F05BB6',]
                xdata.nameList.forEach((item,i) => {
                    seriesData.push({
                        name:item,
                        type:'line',symbol:'circle',showSymbol: false,symbolSize:8,
                        data: xdata.dataList[i]
                    })
                })
                this.$commonEcharts.echartsSix('cljz',xdata.dateList,seriesData,true,color)
            }
        }).catch(err=>{})
    },
    // 月度收益
    getStrategyMonthYield() {
        let vm = this;
        vm.$http.post(vm.$apiPath.GetStrategyMonthYield,{
            Date: vm.monthDate,
        }).then(res=>{
            // console.log(res);
            if(res.data.code == 200) {
                let list = res.data.data.dataList
                let newList = new Array()
                for (let i = 0; i < list.length / 9; i++) {
                    newList[i] = list.slice(i * 9, (i + 1) * 9)
                }
                vm.tacticsArr = newList
            }
        }).catch(err=>{})
    },
    // 指数月度收益
    getMarketIndexMonthYield() {
        let vm = this
        vm.$http.post(vm.$apiPath.GetMarketIndexMonthYield,{
            Date: vm.zsmonthDate,
        }).then(res=>{
            // console.log(res);
            if(res.data.code == 200) {
                let list = res.data.data.dataList
                let newList = new Array()
                for (let i = 0; i < list.length / 9; i++) {
                    newList[i] = list.slice(i * 9, (i + 1) * 9)
                }
                vm.indexMonthYield = newList
            }
        }).catch(err=>{})
    },
    getHCStrategyMonthYield() {
        let vm = this;
        vm.$http.post(vm.$apiPath.GetHCStrategyMonthYield,{
            Date: vm.rxMonthDate,
        }).then(res=>{
            // console.log(res);
            if(res.data.code == 200) {
                let list = res.data.data.dataList
                let newList = new Array()
                for (let i = 0; i < list.length / 9; i++) {
                    newList[i] = list.slice(i * 9, (i + 1) * 9)
                }
                vm.strategyArr = newList
            }
        }).catch(err=>{})
    },
  }
}
</script>

<style lang="less" scoped>
.statistics {
    .time-tab {
        font-size: 14px;color: @color6;padding: 5px 0 20px;
        /deep/.el-radio-button {margin: 0 20px;}
    }
    .row-two .title {min-width: 178px;}
    .row-h {
        height: 40px;background: @tableHeaderColor;line-height: 40px;font-size:18px;
        li {float: left;width: 11.11%;text-align: center;position: relative;}
        li::before {content: "";position: absolute;top: 50%;transform: translateY(-50%);right: 0;width: 1px;height: 24px;background: @colorD5;}
        li:last-child::before {display: none;}
    }
    .row-b {
        height: 66px;line-height: 66px;font-size:24px;
        li {float: left;width: 11.11%;text-align: center;color: @mainColor;}
    }
    .line {width: 100%;margin: 54px 0;border: 1px dashed @colorc;}
}
</style>

